import { render } from "./CompleteEditCompetiton.vue?vue&type=template&id=1faec8c0&scoped=true"
import script from "./CompleteEditCompetiton.vue?vue&type=script&lang=js"
export * from "./CompleteEditCompetiton.vue?vue&type=script&lang=js"

import "./CompleteEditCompetiton.vue?vue&type=style&index=0&id=1faec8c0&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1faec8c0"]])

export default __exports__